import { render } from "./USNyAmlDownload.vue?vue&type=template&id=5d034eca"
import script from "./USNyAmlDownload.vue?vue&type=script&lang=js"
export * from "./USNyAmlDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__